export default __webpack_public_path__ + "static/media/facebook_kod.2683393a.webp";